import { logout } from '../../services/axiosAuth';
import { logout as logoutAction } from '../../reducers/authActions';
import { FormattedMessage } from 'react-intl';
import iconCaretDown from '../../icons/caret-down.svg';
import MenuElement from './MenuElement';
import { connect } from 'react-redux';

const DesktopTopMenu = (props) => {
  return (
    <ul className='links'>
      <li className='company-name-box'>
        <span>{props.data?.companyName}</span>
      </li>
      <li className='link'>
        <a href='#' className='primary-element' onClick={props.handleOpenModal}>
          <FormattedMessage id='Your salesman' />
        </a>
      </li>
      <div className='menu-dropdown link'>
        <div>
          <FormattedMessage id='Settings' />
          <img className='top-bar-icon' src={iconCaretDown} alt='' />
        </div>
        <div className='menu-dropdown-content'>
          <MenuElement to='/settings/password'>
            <FormattedMessage id='Change password' />
          </MenuElement>
          <MenuElement to='/settings/contact'>
            <FormattedMessage id='Change contact information' />
          </MenuElement>
        </div>
      </div>
      <li className='link'>
        <a onClick={() => logout().then(() => props.dispatch(logoutAction()))} className='primary-element'>
          <FormattedMessage id='Sign out' />
        </a>
      </li>
    </ul>
  );
};

export default connect((state) => state.userInfo)(DesktopTopMenu);
